import { render, staticRenderFns } from "./CardConventions.vue?vue&type=template&id=824f0b1c&scoped=true&"
import script from "./CardConventions.vue?vue&type=script&lang=js&"
export * from "./CardConventions.vue?vue&type=script&lang=js&"
import style0 from "./CardConventions.vue?vue&type=style&index=0&id=824f0b1c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "824f0b1c",
  null
  
)

export default component.exports